export const insertIntoQueue = async (url: string, jsonData: string) => {
    let formBody = 'Action=SendMessage&MessageBody=' + encodeURIComponent(jsonData);
    fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: formBody
    }).catch(error => console.error('Error inserting into queue:', error));
};

